"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialDeleteModal = void 0;
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const react_redux_1 = require("react-redux");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const sliceReview_1 = require("../../../../slice/sliceReview");
const store_1 = require("../../../../store");
const selectors_1 = __importDefault(require("../../../../slice/selectors"));
const helper_1 = require("../../../../../reviews/helper");
exports.initialDeleteModal = {
    open: false,
    index: 0,
    stageName: '',
};
const DeleteStageModal = ({ open, index, stageName, setOpenRemoveStageModal, }) => {
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { roundStages } = (0, react_redux_1.useSelector)(selectors_1.default);
    const shouldUpdateFirstStageAfterDelete = () => {
        const nextStage = roundStages[index + 1];
        if (!nextStage)
            return false;
        return index === helper_1.FIRST_STAGE_INDEX && nextStage.triggerTypeId >= helper_1.WHEN;
    };
    const handleDeleteStage = () => {
        const shouldUpdate = shouldUpdateFirstStageAfterDelete();
        dispatch((0, sliceReview_1.removeRoundStage)(index));
        if (shouldUpdate) {
            dispatch((0, sliceReview_1.updateRoundStage)({
                indexStage: helper_1.FIRST_STAGE_INDEX,
                valueUpdate: {
                    triggerTypeId: helper_1.IMMEDIATELY,
                    parentStageId: undefined,
                },
            }));
        }
        if ((0, isFunction_1.default)(setOpenRemoveStageModal)) {
            setOpenRemoveStageModal(exports.initialDeleteModal);
        }
    };
    const handleCloseModal = () => {
        if ((0, isFunction_1.default)(setOpenRemoveStageModal)) {
            setOpenRemoveStageModal(exports.initialDeleteModal);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseModalBase, { headerPrimaryText: "Delete Stage", open: open, onModalClose: handleCloseModal, classes: {
                dialog: {
                    paper: (0, clsx_1.default)(styles_modules_less_1.default['remove-stage-modal__root']),
                },
            }, PulseModalHeaderProps: {
                classes: {
                    root: styles_modules_less_1.default['modal-header__root'],
                    titleContainer: styles_modules_less_1.default['modal-header__ctn'],
                    titlePrimary: styles_modules_less_1.default['modal-header__title'],
                    closeBtn: styles_modules_less_1.default['modal-header__closeBtn'],
                },
                headerIconClasses: (0, clsx_1.default)(styles_modules_less_1.default['modal-header__icon'], 'fal fa-trash-alt'),
            }, footer: false },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['remove-stage-modal__content'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['remove-stage-modal__content--title'] },
                    react_1.default.createElement("p", null, "You are about to delete a stage from this review:"),
                    react_1.default.createElement("p", { className: styles_modules_less_1.default['remove-stage-modal__stage'] }, stageName)),
                react_1.default.createElement("b", null, "Do you wish to proceed?"),
                react_1.default.createElement("section", { className: styles_modules_less_1.default['remove-stage-modal__buttons'] },
                    react_1.default.createElement(pulse_components_1.PulseButton, { onClick: handleCloseModal, classes: [styles_modules_less_1.default['warning-btn']], label: 'CANCEL', icon: true, iconPosition: "left" }),
                    react_1.default.createElement(pulse_components_1.PulseButton, { onClick: handleDeleteStage, classes: [styles_modules_less_1.default['warning-btn']], label: 'Delete Stage', icon: true, iconPosition: "left", color: pulse_components_1.Colors.danger, iconClasses: {
                            icon: (0, clsx_1.default)('fal fa-trash-alt', styles_modules_less_1.default['remove-btn__icon']),
                        } }))))));
};
exports.default = DeleteStageModal;
